<template>
    <div class="container pt-10 csform">
        <TwoColumnLayout>
            <template v-slot:title>
                <h1 class="csform">2021 mastercraft xt21</h1>
            </template>
            <template v-slot:filters>
            </template>
            <template v-slot:form-content>
            </template>
            <template v-slot:address>
                <contact-seller :hin="hin" />
            </template>
        </TwoColumnLayout>
    </div>
</template>
<script>
    import TwoColumnLayout from "../components/molecules/TwoColumnLayout.vue";
    import ContactSeller from "../components/InputForms/ContactSeller.vue";
    export default {
        name: "ContactSellerForm",
        components: {
            TwoColumnLayout,
            ContactSeller
        },
        props: {
            hin: null,
        },
        data() {
            return {
            };
        }
    };
</script>